class HTTPError extends Error {
  constructor({ code = 'server_error', detail = 'Server Error', ...extra } = {}, ...params) {
    super(code, ...params);
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HTTPError);
    }
    this.code = code;
    this.detail = detail;
    this.extra = extra;
  }
}

const errorMatchesPattern = (pattern = {}) => (error = {}) => {
  return Object.keys(pattern).every(key => error && error[key] && error[key] === pattern[key]);
};

export const isTrialOutOfStock = errorMatchesPattern({
  code: 'trial_kit_out_of_stock',
});
export const isFirstOrderOnly = errorMatchesPattern({
  code: 'first_order_only',
});

export const isPaymentInvalid = error =>
  [
    'card_declined',
    'incorrect_cvc',
    'incorrect_number',
    'expired_card',
    'processing_error',
    'prepaid_card_error',
  ].some(code => errorMatchesPattern({ code })(error));

// error signature for geo agressor service with unknown zipcode
export const isInvalidZipcode = errorMatchesPattern({
  code: 'invalid_hair_profile',
  detail: 'Cannot fetch aggressors from hair profile',
});

export const isInvalidHairProfile = errorMatchesPattern({
  code: 'invalid_hair_profile',
});

export const isInvalidAuthToken = errorMatchesPattern({
  code: 'auth_invalid_token',
});

export const isInvalidCoupon = error =>
  [
    'coupon_error',
    'coupon_already_redeemed',
    'coupon_inactive',
    'coupon_invalid',
    'coupon_invalid_precondition',
    'coupon_invalid_type',
    'coupon_too_many_usage',
  ].some(code => errorMatchesPattern({ code })(error));

export const isUnknownUser = errorMatchesPattern({
  code: 'auth_unknown_user',
});

export const isExistingUser = errorMatchesPattern({
  code: 'auth_existing_user',
});

export const isValidationError = errorMatchesPattern({
  code: 'error',
});

export const isFetchError = errorMatchesPattern({
  code: 'failed_to_fetch',
});

export const isInvalidStylistSlug = errorMatchesPattern({
  code: 'invalid_stylist_slug',
  detail: 'Stylist not found',
});

export const isInvalidOrderFilter = errorMatchesPattern({
  code: 'invalid_order_filter',
});

export default HTTPError;
